"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fade = void 0;
const styled_components_1 = require("styled-components");
const foundation_1 = require("../foundation");
exports.fade = {
    base: {
        ids_fade_general_in: (0, styled_components_1.css) `
      @keyframes ids_fade_general_in {
        from {
          opacity: ${foundation_1.foundation_fade.fade.fade_0};
        }

        to {
          opacity: ${foundation_1.foundation_fade.fade.fade_100};
        }
      }
    `,
        ids_fade_general_out: (0, styled_components_1.css) `
      @keyframes ids_fade_general_out {
        from {
          opacity: ${foundation_1.foundation_fade.fade.fade_100};
        }

        to {
          opacity: ${foundation_1.foundation_fade.fade.fade_0};
        }
      }
    `,
    },
};
//# sourceMappingURL=fade.js.map